module.exports = __webpack_public_path__ + "img/v1.8cd079b0.png";